import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const AppContentViewWrapper = ({children, ...rest}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        maxWidth: {xl: 1650},
        mx: {xl: 'auto'},
        width: {xl: '100%'},
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

AppContentViewWrapper.propTypes = {
  children: PropTypes.node,
};

export default AppContentViewWrapper;
